<template>
  <svg class="fts-moji" :width="size" :height="size" :style="{ 'min-width': `${size}px` }">
    <use :xlink:href="getEmoji" v-if="isVisible" />
  </svg>
</template>

<script>
import twemoji from "../../assets/twemoji/emoji.svg";

const vs16RegExp = /\uFE0F/g;
const zeroWidthJoiner = String.fromCharCode(0x200d);
const removeVS16s = rawEmoji => (rawEmoji.indexOf(zeroWidthJoiner) < 0 ? rawEmoji.replace(vs16RegExp, '') : rawEmoji);
const toCodePoints = (unicodeSurrogates) => {
  const points = [];
  let char = 0;
  let previous = 0;
  let i = 0;
  while (i < unicodeSurrogates.length) {
    char = unicodeSurrogates.charCodeAt(i++);
    if (previous) {
      points.push((0x10000 + ((previous - 0xd800) << 10) + (char - 0xdc00)).toString(16));
      previous = 0;
    } else if (char > 0xd800 && char <= 0xdbff) {
      previous = char;
    } else {
      points.push(char.toString(16));
    }
  }
  return points;
}

export default {
  props: {
    emoji: String,
    size: {
      type: Number,
      default: 25
    },
  },
  data: () => ({
    twemoji: twemoji,
    observer: null,
    isVisible: false
  }),
  computed: {
    getEmoji() {
      if (this.emoji)
        return `${this.twemoji}#${toCodePoints(removeVS16s(this.emoji)).join('-')}`;
    }
  },
  mounted() {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.isVisible = true;
          this.observer.unobserve(entry.target);
        }
      });
    });

    this.observer.observe(this.$el);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};
</script>

<style lang="scss" scope>
.fts-moji {
  display: block;
}
</style>